import React from 'react';
import DatePicker from 'react-datepicker';
import './style.scss';
import { useTranslation } from '@common/hooks/translation';

const CustomDatePicker = ({ value, onChange, errorMessage }) => {
  const t = useTranslation();
  return (
    <>
      <div className="date-picker-date-of-birth">
        <DatePicker
          selected={value || null}
          onChange={onChange}
          dateFormat="dd/MM/yyyy"
          maxDate={new Date()}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          className="datepicker-input"
          calendarClassName="react-datepicker"
        />
      </div>
      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </>
  );
};

export default CustomDatePicker;
